import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // Define your state here
  },
  mutations: {
    // Define your mutations here
  },
  actions: {
    // Define your actions here
  },
  modules: {
    // Define your modules here if any
  }
})